// Ad Link Configuration
export const AD_LINK = 'https://otieu.com/4/8368530';
export const AD_VIEW_DURATION_MS = 10000; // 10 seconds for ad view
